module.exports = __webpack_public_path__ + "img/account.3c3b4b81.svg";